import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const commands = [
  { id: 'newProject', name: 'Nuevo Proyecto', description: 'Crear un nuevo proyecto', path: '/projects/new', icon: '➕' },
  { id: 'tasks', name: 'Tareas', description: 'Ver tus tareas pendientes', path: '/tasks', icon: '✅' },
];

function CommandPalette({ isOpen, setIsOpen }) {
  const [query, setQuery] = useState('');
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [filteredCommands, setFilteredCommands] = useState(commands);
  const inputRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);

  useEffect(() => {
    if (query.trim() === '') {
      setFilteredCommands(commands);
    } else {
      const filtered = commands.filter(
        command =>
          command.name.toLowerCase().includes(query.toLowerCase()) ||
          command.description.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredCommands(filtered);
    }
    setSelectedIndex(0);
  }, [query]);

  const handleKeyDown = (e) => {
    // Arrow Down
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setSelectedIndex(prevIndex => 
        prevIndex < filteredCommands.length - 1 ? prevIndex + 1 : prevIndex
      );
    }
    // Arrow Up
    else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setSelectedIndex(prevIndex => 
        prevIndex > 0 ? prevIndex - 1 : prevIndex
      );
    }
    // Enter
    else if (e.key === 'Enter') {
      e.preventDefault();
      if (filteredCommands[selectedIndex]) {
        selectCommand(filteredCommands[selectedIndex]);
      }
    }
    // Escape
    else if (e.key === 'Escape') {
      e.preventDefault();
      setIsOpen(false);
    }
  };

  const selectCommand = (command) => {
    setIsOpen(false);
    navigate(command.path);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto p-4 sm:p-6 md:p-20" aria-labelledby="command-palette-label">
      <div className="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity" onClick={() => setIsOpen(false)}></div>
      <div className="relative mx-auto max-w-2xl transform rounded-xl bg-[#1e1e1e] shadow-2xl ring-1 ring-[#2a2a2a] transition-all">
        <div className="px-4 pt-5 pb-6 sm:px-6">
          <div className="flex items-center justify-between">
            <h2 id="command-palette-label" className="text-lg font-medium text-white">Comando rápido</h2>
            <button
              type="button"
              className="text-gray-400 hover:text-gray-200"
              onClick={() => setIsOpen(false)}
            >
              <span className="sr-only">Cerrar</span>
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <div className="mt-4">
            <input
              ref={inputRef}
              type="text"
              className="block w-full rounded-md bg-[#121212] border-[#2a2a2a] text-white focus:border-[#ff1b6d] focus:ring focus:ring-[#ff1b6d] focus:ring-opacity-50"
              placeholder="Buscar comandos..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              onKeyDown={handleKeyDown}
            />
          </div>
        </div>
        <ul className="max-h-80 overflow-y-auto px-4 pb-4 sm:px-6 sm:pb-6">
          {filteredCommands.length === 0 ? (
            <li className="px-4 py-3 text-center text-gray-400">No hay resultados</li>
          ) : (
            filteredCommands.map((command, index) => (
              <li 
                key={command.id}
                className={`px-4 py-3 rounded-md cursor-pointer ${selectedIndex === index ? 'bg-[#2a2a2a]' : 'hover:bg-[#2a2a2a]'}`}
                onClick={() => selectCommand(command)}
              >
                <div className="flex items-center">
                  <span className="text-lg mr-3">{command.icon}</span>
                  <div>
                    <h3 className="text-sm font-medium text-white">{command.name}</h3>
                    <p className="text-xs text-gray-400">{command.description}</p>
                  </div>
                </div>
              </li>
            ))
          )}
        </ul>
      </div>
    </div>
  );
}

export default CommandPalette;
